module.exports = __webpack_public_path__ + "img/logo02.d538d865.png";